define ['./applications.scss'], () ->
  ($scope, $state, $rootScope, $timeout, $stateParams, HOST) ->
    # step1_green_svg = require('./../../images/step1-green.svg')
    # step1_gray_svg = require('./../../images/step1-gray.svg')
    # step2_green_svg = require('./../../images/step2-green.svg')
    # step2_gray_svg = require('./../../images/step2-gray.svg')
    # step3_green_svg = require('./../../images/step3-green.svg')
    # step3_gray_svg = require('./../../images/step3-gray.svg')
    # step4_green_svg = require('./../../images/step4-green.svg')
    # step4_gray_svg = require('./../../images/step4-gray.svg')
    # step_complete_svg = require('./../../images/step-complete.svg')
    # step_failed_svg = require('./../../images/step-failed.svg')

    # $scope.step1 = step1_green_svg
    # $scope.step2 = step2_gray_svg
    # $scope.step3 = step3_gray_svg
    # $scope.step4 = step4_gray_svg

    $scope.current_step_index = 0

    $scope.steps_mapping = [
      'root.applications.apply',
      'root.applications.create_account',
    ]

    $scope.show_progress_bar = true

    $scope.$watch(() ->
      $state.$current.name
    , (newVal, oldVal) ->
      if newVal.indexOf('root.applications.apply_sample') >= 0
        $scope.current_state = 'root.applications.apply'
      else
        $scope.current_state = newVal
      if ['root.applications.customize', 'root.applications.edit', 'root.applications.form_edit'].indexOf($scope.current_state) >= 0
        $scope.show_progress_bar = false
      $scope.set_active($scope.current_state)
      # $scope.set_ready($scope.current_state)
    )

    $scope.mobile_view = window.innerWidth < 768

    $scope.go_to_customize = (apptemplate) ->
      window.location.replace("#{HOST}/customize/#{apptemplate.slug}")

    progressBar = $(".row.top")
    stickyFixed = "fixed"
    aboveProgressBarHeight =  60
    $(window).scroll ->
      if $scope.current_state == 'root.applications.customize' or $scope.current_state == 'root.applications.edit'
         return
      
      if $(this).scrollTop() > aboveProgressBarHeight
        progressBar.addClass stickyFixed
        $scope.$apply () -> $scope.buffer_content = true
      else
        progressBar.removeClass stickyFixed
        $scope.$apply () -> $scope.buffer_content = false
      return

    $scope.set_progress_bar = (application) ->
      if application.selected_report_sources and (application.selected_report_sources.join('').indexOf('experian_credit') >= 0 or application.selected_report_sources.join('').indexOf('smartmove') >= 0)
        $scope.display_verify = true
        $scope.steps_mapping = $scope.steps_mapping.concat([
          'root.applications.verify.disclaimer',
          'root.applications.verify.personal_info',
          'root.applications.verify.questions',
          'root.applications.verify.verify_success',
          'root.applications.verify.verify_fail',
        ])

      if application.selected_report_sources and application.selected_report_sources.join('').indexOf('mvga_employment_plus') >=0
        $scope.display_income = true
        $scope.steps_mapping.push('root.applications.income')

      if application.price > 0
        $scope.display_payment = true
        $scope.steps_mapping.push('root.applications.pay')

      if $scope.mobile_view
        $scope.base_width = 160
        $scope.base_item_width = 60
      else
        $scope.base_width = 280
        $scope.base_item_width = 140
      
      $scope.steps_mapping = $scope.steps_mapping.concat(['root.applications.apply_success', 'root.application.fail'])

      $scope.progress_bar_width = "#{$scope.base_width + $scope.base_item_width * ($scope.display_verify) + $scope.base_item_width * ($scope.display_income) + $scope.base_item_width * (application.price > 0)}px"

    if !$stateParams.application
      $scope.display_verify = false
      $scope.display_payment = false
      $scope.display_income = false
    else
      $scope.set_progress_bar($stateParams.application)

    $scope.show_report = (apptemplate, report_type) ->
      _.find(apptemplate.landlord.report_source_profiles, {'short_label': report_type})

    $scope.set_active = (current_state) ->
      current_index = $scope.steps_mapping.indexOf(current_state)
      $scope.current_step_index = current_index

      # $scope.active_mapping = {}

      # if current_index >= 0
      #   $scope.active_mapping.app = true
      #   $scope.step1 = step1_green_svg
      # if current_index >= 1
      #   $scope.active_mapping.create = true
      #   $scope.step2 = step2_green_svg
      # if current_index >= 2
      #   $scope.active_mapping.verify = true
      #   $scope.step3 = step3_green_svg
      # if current_index >= 7
      #   $scope.active_mapping.payment = true
      #   $scope.step4 = step4_green_svg

    $scope.set_ready = (current_state) ->
      current_index = $scope.steps_mapping.indexOf(current_state)

      $scope.ready_mapping = {}

      if current_index > 0
        $scope.ready_mapping.app = true
        $scope.step1 = step_complete_svg
      if current_index > 1
        $scope.ready_mapping.create = true
        $scope.step2 = step_complete_svg
      if current_index >= 5
        $scope.ready_mapping.verify = true
        if $scope.display_verify
          if current_state == 'root.applications.verify.verify_fail' or $scope.verify_failed
            $scope.verify_failed = true
            $scope.step3 = step_failed_svg
          else
            $scope.step3 = step_complete_svg
      if current_index > 7
        $scope.ready_mapping.payment = true
        $scope.step4 = step_complete_svg
        if !$scope.display_verify
          $scope.step3 = step_complete_svg

    $rootScope.$on "apptemplate-loaded", (event, data) ->
      $scope.apptemplate = data.apptemplate
      $scope.set_progress_bar($scope.apptemplate)



// WEBPACK FOOTER //
// ./components/applications/applications.coffee